// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1tvaZ","header":"PatientBlock_header__3XTJF","label":"PatientBlock_label__2lK-c","option":"PatientBlock_option__2-wcW"};